import React, { Component } from 'react'
import { withCookies } from 'react-cookie'
import CookieBanner from './CookieBanner'
import { Provider, Consumer } from './Context'
import { DAY_IN_SECONDS } from 'constant'

class CookieAcceptance extends Component {
  static Provider = Provider
  static Consumer = Consumer

  constructor(props) {
    super(props)

    this.state = {
      cookiesAccepted: props.cookies.get('cookiesAccepted') === 'true',
      acceptHightlighted: false
    }
  }

  handleAccept = e => {
    this.setCookiesAccepted(true)
    e.preventDefault()
  }

  resetCookies() {
    const { cookies } = this.props
    Object.keys(cookies.getAll()).forEach(key => cookies.remove(key))
  }

  setCookiesAccepted = value => {
    if (value) {
      this.props.cookies.set('cookiesAccepted', value, {
        path: '/',
        maxAge: 30 * DAY_IN_SECONDS,
        secure: true
      })
    } else {
      this.resetCookies()
    }
    this.setState({ cookiesAccepted: value })
  }

  highlightAcceptCookiesButton = (acceptHightlighted = true) =>
    this.setState({ acceptHightlighted })

  render() {
    const { cookiesAccepted, acceptHightlighted } = this.state
    const { children } = this.props
    return (
      <Provider
        value={{
          cookiesAccepted,
          setCookieAcceptance: this.setCookiesAccepted,
          highlightAcceptCookiesButton: this.highlightAcceptCookiesButton
        }}
      >
        {!cookiesAccepted && (
          <CookieBanner
            onAccept={this.handleAccept}
            highlighted={acceptHightlighted}
          />
        )}
        {children}
      </Provider>
    )
  }
}

export default withCookies(CookieAcceptance)



// WEBPACK FOOTER //
// ./src/components/CookieAcceptance/index.js